<!-- 用户操作 -->
<template>
    <div>
        <el-drawer :close-on-press-escape="true" :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus"
            :with-header="false" :append-to-body="true" :direction="dataActionBox.openMode" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="formDataList" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form size="mini" inline :show-message="false" label-width="120px"
                                        :model="sendDataInfo" ref="sendDataInfo">
                                        <el-form-item label="临时授信额度" prop="tempMoney"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('临时授信额度')"
                                                v-html="$common.htmlLabel('临时授信额度')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.tempMoney"
                                                placeholder="请输入临时授信额度" :maxlength="$store.state.inputLength"
                                                type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item label="临时信贷期" prop="tempPeriod"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('临时信贷期')"
                                                v-html="$common.htmlLabel('临时信贷期')"></label>
                                            <el-input class="form_codition" v-model.trim="sendDataInfo.tempPeriod"
                                                placeholder="请输入临时信贷期" :maxlength="$store.state.inputLength"
                                                type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item label="有效期" prop="validity"
                                            :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('有效期')"
                                                v-html="$common.htmlLabel('有效期')"></label>
                                            <el-date-picker class="form_codition" size="mini"
                                                v-model="sendDataInfo.validity" format="yyyy 年 MM 月 dd 日"
                                                value-format="timestamp" type="date" placeholder="选择日期">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-form>
                                </div>

                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')">保存</el-button>
                </div>
            </div>
            <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
                <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                    @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            </el-dialog>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "operCreditActionLin",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            showTabs: '',
            formDataList: [],
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                tempMoney: "",
                tempPeriod: '',
                validity: "",
            },
            defaultProps: {
                multiple: true,
                expandTrigger: 'hover',
                checkStrictly: true,
                emitPath: false,
            },
            fileList: [],
            allorgList: [],
            dialogImageUrl: '',
            DialogVisible: false,
            selectedDataList: [],
            departmentList: [],
            groupList: [],
            customertype: [{
                lable: 0,
                name: "普通用户",
            },
            {
                lable: 1,
                name: "货主用户",
            },
            ],
            dictionariesData: [], //男女字典
            sField: "",
            seId: "",
            seType: "",
            parentSearchData: {},
            seWidth: "0",
            exWidth: "",
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;

                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName' && this.sendDataInfo.cmId == '') {
                return this.$message({
                    message: '请先选择购进单位',
                    type: "warning",
                });
            }
            this.DialogVisible = true
            this.seType = type
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        cancel() {
            this.dataActionBox.showStatus = false
        },


        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.dataActionBox.showStatus = false;
        },

        async openBox(cate, oldData) {
            this.fileList = []
            if (cate == 3) {
                this.initActionBox();
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "ltr";
                for (let key in oldData) {
                    this.sendDataInfo[key] = oldData[key];
                }
                this.showTabs = "编辑临时授信"
                this.formDataList = [
                    {
                        jciName: "编辑临时授信",
                        jurconfigform: [],
                    }
                ]
            }
            this.dataActionBox.actionType = cate;
            this.dataActionBox.showStatus = true;
        },

        sendDataAction(sendDataInfo) {

            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            var time = new Date().getTime()
            if (this.sendDataInfo.validity < time) {
                return this.$message.error("有效期必须大于当天")
            }
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 3) {
                var responseData = await this.$http.opercreditUpdateTemp(sendDataInfo);
            }
            if (responseData.status == 200) {
                this.initActionBox();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });

                this.$parent.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [1],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "字典项获取失败",
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.getGroupList();
        this.getPartDictionariesData();
        // this.getOrgList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>